<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Grados</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear grado</strong>
            </h5>
          </div>
        </div>
        <b-form @submit="save">
          <div class="row">
            <div class="col-md-4">
              <b-form-group id="input-group-1" label="Nombre:" label-for="input-1" description="Ejemplo: Tercero">
                <b-form-input id="input-1" v-model="form.name" required placeholder="Ingrese el nombre del grado" trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-2" label="Número:" label-for="input-2" description="Ejemplo: 3. Si no aplica ingrese de nuevo el nombre del grado, ejemplo: Tercero">
                <b-form-input id="input-2" v-model="form.abbreviation" required placeholder="Ingrese el grado en formato de número o abreviación"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-3" label="Orden:" label-for="input-3">
                <b-form-select v-model="form.order" :options="orderOptions" required></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="row" v-if="qualificationOptions.length > 0 && levels.length > 0">
            <div class="col-md-4">
              <b-form-group id="input-group-4" label="Nivel de escolaridad:" label-for="input-4">
                <b-form-select v-model="form.idEducationLevel" :options="levels" required></b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group id="input-group-5" label="Rango de calificación:" label-for="input-4">
                <b-form-select v-model="form.idQualificationRange" :options="qualificationOptions" required></b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-4 align-self-center">
              <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
            </div>
          </div>
          <div v-else>
            <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
          </div>
        </b-form>
        <a-divider />
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de grados</strong>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <a-table :columns="columns" :dataSource="data" rowKey="id">
                 <div slot="action" slot-scope="grade">
                  <b-link class="btn btn-light mr-2" @click="openModal(grade)">
                    <i class="fa fa-pencil text-blue" /> Editar
                  </b-link> |
                  <b-link class="btn btn-light mr-2" @click="deleteGrade(grade)"><i class="fa fa-trash-o text-red" /> Eliminar</b-link>
                </div>
              </a-table>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-grade" ref="modal" title="Editar grado" hide-footer @hidden="onHidden">
      <b-form @submit="edit" ref="todoform">
        <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-2" description="Ejemplo: Tercero">
          <b-form-input id="input-1-edit" v-model="gradeToEdit.name" required placeholder="Ingrese el nombre de grado"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2-edit" label="Número:" label-for="input-2" description="Ejemplo: 3. Si no aplica ingrese de nuevo el nombre del grado, ejemplo: Tercero">
          <b-form-input id="input-2-edit" v-model="gradeToEdit.abbreviation" required placeholder="Ingrese el grado en formato de número o abreviación"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-3-edit" label="Orden:" label-for="input-3-edit">
          <b-form-select v-model="gradeToEdit.order" :options="orderOptions" required></b-form-select>
        </b-form-group>
        <b-form-group id="input-group-4-edit" label="Nivel de escolaridad:" label-for="input-4-edit">
          <b-form-select v-model="gradeToEdit.idEducationLevel" :options="levels" required></b-form-select>
        </b-form-group>
        <b-form-group id="input-group-5-edit" label="Rango de calificación:" label-for="input-5-edit">
          <b-form-select v-model="gradeToEdit.idQualificationRange" :options="qualificationOptions" required></b-form-select>
        </b-form-group>
        <b-button @click="$bvModal.hide('edit-grade')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import { showErrorMessage } from '@/services/utilities'

const columns = [
  { title: 'Código', dataIndex: 'id', key: 'id' },
  { title: 'Grado', dataIndex: 'name', key: 'grade' },
  { title: 'Número', dataIndex: 'abbreviation', key: 'number' },
  { title: 'Acción', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'ManagementGrade',
  data() {
    return {
      form: {
        name: '',
        abbreviation: '',
        idEducationLevel: null,
        order: null,
        idQualificationRange: null,
      },
      gradeToEdit: {
        name: '',
        abbreviation: '',
        idEducationLevel: null,
        order: null,
        idQualificationRange: null,
      },
      levels: [],
      data: null,
      orderOptions: [],
      qualificationOptions: [],
      columns,
    }
  },
  beforeRouteEnter (to, from, next) {
    function getGrades() {
      return apiClient2.get('/grades')
    }

    function getEducationLevels() {
      return apiClient2.get('/education-levels')
    }
    function getAssesments() {
      return apiClient.get('/qualifications/assessments')
    }

    axios.all([getGrades(), getEducationLevels(), getAssesments()])
      .then(axios.spread(function (grades, levels, assesments) {
        next((vm) => {
          vm.setData(null, grades.data)
          vm.setDataLevels(null, levels.data.data.rows)
          vm.setDataRanges(null, assesments.data.rows)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setData(err, [])
          vm.setDataRanges(err, [])
          vm.setDataLevels(err, [])
        })
      })
  },
  methods: {
    setData (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.orderOptions = []
        this.data = data.data
        this.orderOptions.push({
          text: 'Seleccione el orden...',
          value: null,
        })
        for (let i = 1; i < this.data.length + 1; i++) {
          this.orderOptions.push({
            text: i,
            value: i,
          })
        }
      }
    },
    setDataLevels (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        for (const level of data) {
          this.levels.push({ value: level.id, text: level.name })
        }
        this.levels.unshift({ value: null, text: 'Seleccione una opción' })
      }
    },
    save(evt) { // Guarda un grado llamando a la API
      evt.preventDefault()
      apiClient2.post('/grades', this.form).then(response => {
        this.data.push(response.data.data)
        this.onHidden()
        this.$notification.success({
          message: 'Creado exitosamente',
          description: `El grado ${response.data.data.name} fue creado con éxito.`,
        })
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    openModal(gradeIn) { // Abre el modal para editar el grado
      this.gradeToEdit = Object.assign({}, gradeIn)
      this.$bvModal.show('edit-grade')
    },
    edit(evt) { // Edita un grado llamando a la API
      evt.preventDefault()
      apiClient2.put(`/grades/${this.gradeToEdit.id}`, this.gradeToEdit).then(response => {
        this.search()
        this.$bvModal.hide('edit-grade')
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            `Se modificó el grado ${this.gradeToEdit.name} correctamente.`,
        })
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    deleteGrade(grade) {
      Swal.fire({
        title: 'Mensaje de confirmación',
        text: '¿Desea eliminar el grado ' + grade.name + '? Se borrarán todos los datos relacionados al grado seleccionado.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar.',
        cancelButtonText: 'No.',
      }).then((result) => {
        if (result.isConfirmed) {
          apiClient2.delete(`/grades/${grade.id}`).then(response => {
            this.search()
            this.$notification.success({
              message: 'Eliminación exitosa',
              description: `El grado ${grade.name} fue eliminado con éxito.`,
            })
          }).catch(e => {
            this.$notification.success({
              message: 'Ooops ocurrio un error',
              description: showErrorMessage(e),
            })
          })
        }
      })
    },
    search() {
      apiClient2.get('/grades').then(response => {
        this.setData(null, response.data)
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
    onHidden() {
      this.form.name = ''
      this.form.abbreviation = ''
      this.form.idEducationLevel = null
      this.form.idQualificationRange = null
      this.gradeToEdit.name = ''
      this.gradeToEdit.abbreviation = ''
      this.gradeToEdit.idEducationLevel = null
      this.gradeToEdit.idQualificationRange = null
    },
    setDataRanges (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        if (data.length > 0) {
          this.qualificationOptions = data.map(x => {
            return {
              value: x.id,
              text: x.name,
              type: x.type,
            }
          })
          this.qualificationOptions.unshift({ value: null, text: 'Seleccione un rango' })
        }
      }
    },
    // handleOk(bvEvt) {
    //   // This assumes the root element of the todo form is the <form>
    //   // this.$refs.todoform.$el.submit()
    //   // Alternatively, if your Todo Form exposes a submit method
    //   this.$refs.todoform.submit()
    //   this.$refs.form.submit()
    // },
  },
}
</script>
